/**
 * @file Icon 补充
 * @author alfielv
 */
import React from 'react';
import { PREFIX_CLS } from '../../constants';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-icon");
;

var Icon = function Icon(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? '' : _props$type;
  return /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, " ").concat(prefixCls, "-").concat(type)
  });
};

Icon.defaultProps = {};
export default Icon;